/**
 * Lifecycle contract used by the cart, collection and search components.
 * Wrap legacy theme elements explicitly so their own lifecycle still runs.
 * Listeners and subscriptions are released when Shopify replaces a section.
 */
function BaseElementMixin(Base) {
  return class extends Base {
    connectedCallback() {
      super.connectedCallback?.();
    }

    disconnectedCallback() {
      try {
        super.disconnectedCallback?.();
      } finally {
        const cleanups = this._ffCleanups || [];
        this._ffCleanups = [];
        cleanups.forEach((cleanup) => cleanup());
      }
    }

    registerCleanup(cleanup) {
      if (typeof cleanup !== 'function') return;
      (this._ffCleanups ||= []).push(cleanup);
      return cleanup;
    }

    on(node, name, callback, options) {
      if (!node?.addEventListener) return;
      node.addEventListener(name, callback, options);
      return this.registerCleanup(() => node.removeEventListener(name, callback, options));
    }
  };
}

class BaseElement extends BaseElementMixin(HTMLElement) {}
